import { useNavigate, useSearchParams } from 'react-router-dom';
import { AddBindingUserPage } from '@practium/features/users';
import type { BindingTab } from '@practium/features/users';

export const AddUserPageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as BindingTab) || 'farmers';

	return (
		<AddBindingUserPage type={type} onBack={() => navigate('/usuarios')} />
	);
};
